module.exports = __webpack_public_path__ + "img/pictures.61a32771.jpg";